module.exports = __webpack_public_path__ + "img/600.f3f0752b.svg";